import { SERVICES } from "../../../../../../../../enums/QueryKeys";
import { fetchServices } from "../../../../../../../../enums/queryFunction/Fetch";
import { useQuery } from "@tanstack/react-query";
import useSubmit from "../../../../../../../master/species/hooks/useSubmit";
import { PRICES_BASE_REQUEST } from "../../../../../../../../enums/ApiPaths";

export default function useGetServices(clinic_id) {
  const { data, isLoading, error } = useQuery({
    queryKey: [SERVICES + clinic_id],
    queryFn: () => fetchServices(clinic_id),
    staleTime: Infinity,
  });

  return { data, isLoading, error };
}

export function useServiceMutation(clinic_id) {
  const url = PRICES_BASE_REQUEST + clinic_id;
  const { loading, submitCallback } = useSubmit(
    null,
    url,
    null,
    [SERVICES + clinic_id]
  );

  return { loading, submitCallback };
}
